import React, { useEffect } from "react";
import { Checkbox, Grid, Typography } from "@material-ui/core";
import { Label } from "../../../../../../../components/formInputs";
import { NumberTextField } from "../../../../../../../components/formikFormInputs";
import * as Yup from "yup";
import { Formik } from "formik";
import GetFormContent from "../../Beneficiaries/BeneficiariesList/GetFormContent";
import InputAdornment from "@material-ui/core/InputAdornment";
import numeral from "numeral";
import NumberFormat from "react-number-format";
import { payloadDataHandler } from "../index";

const UnearnedIncomePastYear = (props: any) => {
	const {
		autoSaveTrigger,
		financialAndLiabilitiesArr,
		formType,
		isFromClientDetail,
		setFinancialAndLiabilitiesArr,
		setFormType,
		setSaveFormContent,
		setUnEarnedVerified,
		setUnEarnedVerifyRef,
		unearnedIncomePastYearRef,
		user,
	} = props;
	const clientSigned = user && user.enrollment && user.enrollment.clientSigned ? 1 : 0;
	const [isConfirmCheckbox, setIsConfirmCheckbox] = React.useState(!!(user && user.client && user.client.verifyUnEarnedIncome));

	const unEarnedVerifyRef = React.useRef<any>();
	useEffect(() => {
		if (unEarnedVerifyRef.current && typeof setUnEarnedVerifyRef === "function") {
			setUnEarnedVerifyRef(unEarnedVerifyRef);
		}
	}, [unEarnedVerifyRef.current]);

	useEffect(() => {
		setUnEarnedVerified(isConfirmCheckbox);
	}, [isConfirmCheckbox]);

	const fieldObj = [
		{
			id: "pensionSocialSecurity",
			name: "pensionSocialSecurity",
			helperText: "",
			label: <Label label={"Pension/Social Security"} required={false} />,
			isRequired: true,
			className: "mt10",
			component: NumberTextField,
			InputProps: {
				startAdornment: <InputAdornment disableTypography={true}
												position="start">$</InputAdornment>,
			},
			variant: "outlined",
			size: {
				md: 6,
				xl: 4,
			},
			disabled: !!clientSigned
		},
		{
			id: "disabilityPayments",
			name: "disabilityPayments",
			helperText: <span className="f12 textLight">If Applicable</span>,
			label: <Label label={"Disability Payments, if Applicable"} required={false} />,
			isRequired: false,
			className: "mt10",
			component: NumberTextField,
			InputProps: {
				startAdornment: <InputAdornment disableTypography={true}
												position="start">$</InputAdornment>,
			},
			variant: "outlined",
			size: {
				md: 6,
				xl: 4,
			},
			disabled: !!clientSigned
		},
		{
			id: "dividendsInterest",
			name: "dividendsInterest",
			helperText: "",
			label: <Label label={"Dividends / Interest"} required={false} />,
			isRequired: false,
			className: "mt10",
			component: NumberTextField,
			InputProps: {
				startAdornment: <InputAdornment disableTypography={true}
												position="start">$</InputAdornment>,
			},
			variant: "outlined",
			size: {
				md: 6,
				xl: 4,
			},
			disabled: !!clientSigned
		},
		{
			id: "rentalsRoyalties",
			name: "rentalsRoyalties",
			helperText: "",
			label: <Label label={"Rentals / Royalties"} required={false} />,
			isRequired: false,
			className: "mt10",
			filedType: "string",
			component: NumberTextField,
			InputProps: {
				startAdornment: <InputAdornment disableTypography={true}
												position="start">$</InputAdornment>,
			},
			variant: "outlined",
			size: {
				md: 6,
				xl: 4,
			},
			disabled: !!clientSigned
		},
		{
			id: "otherUnEarnedIncome",
			name: "otherUnEarnedIncome",
			helperText: "",
			label: <Label label={"Other"} required={false} />,
			isRequired: false,
			className: "mt10",
			component: NumberTextField,
			InputProps: {
				startAdornment: <InputAdornment disableTypography={true}
												position="start">$</InputAdornment>,
			},
			variant: "outlined",
			size: {
				md: 6,
				xl: 4,
			},
			disabled: !!clientSigned
		},
	];

	/*Set initial values*/
	const initialValues = {};
	/* Validations of fields set */
	let keysValidation = {};

	fieldObj.forEach((field) => {
		initialValues[field.name] = user && user.client && user.client[field.name] || "";
	});

	const validationSchema = Yup.object().shape(keysValidation);

	return (

		<Grid container spacing={2}>
			<Grid item xs={12} md={12}>
				<Formik
					innerRef={unearnedIncomePastYearRef}
					initialValues={initialValues}
					enableReinitialize={true}
					validationSchema={validationSchema}
					validateOnChange={true}
					onSubmit={async (values: any, { setSubmitting }) => {
						try {
							let payload: any = payloadDataHandler(values, "UN_EARNED", isConfirmCheckbox);

							const index = financialAndLiabilitiesArr.findIndex((item) => item.formType === "UN_EARNED");
							if (index > -1) {
								financialAndLiabilitiesArr.splice(index, 1);
							}
							setFinancialAndLiabilitiesArr([...financialAndLiabilitiesArr, {
								...payload,
							}]);

							setTimeout(() => {
								setSubmitting(false);
							}, 400);
						} catch (e) {
							return false;
						}
					}}
				>
					{
						(formikProps) => {
							let totalValues: number = 0;
							Object.values(formikProps.values).map((value) => totalValues = totalValues + (numeral(value).value() || 0));
							return (
								<form className="floatLeft w100" onBlur={autoSaveTrigger}
									  onSubmit={formikProps.handleSubmit}>
									<Grid container spacing={2}>
										<Grid item xs={12}>
											<span className="hLine" />
											<Typography variant="body1" component="strong"
														className="floatLeft w100 mb20">
												Unearned Income - Past Year
												<span className="floatRight">
                                                            Total Unearned Income:
                                                            <NumberFormat
																value={totalValues || 0}
																displayType={"text"}
																thousandSeparator={true}
																prefix={"$"}
															/>
                                                        </span>
											</Typography>
											<Typography variant="caption"
														className="textLight mb15 floatLeft w100">
												Fill out or verify any unearned income you have below making any
												necessary changes. If a particular field doesn’t apply you can
												leave it blank.
											</Typography>
										</Grid>
									</Grid>
									<GetFormContent isFromClientDetail={isFromClientDetail}
													fieldObj={fieldObj} {...formikProps}
													enableOnChangeSubmit={false}
													setSaveFormContent={setSaveFormContent}
													formType={formType} setFormType={setFormType}
									/>
									{!isFromClientDetail &&
										<Grid container spacing={2}>
											<Grid item xs={12}>
												<div style={{ display: "flex", alignItems: "center" }}
													 className="mt20"
													 id="unEarnedVerifyRef" ref={unEarnedVerifyRef}>
													<Checkbox
														style={{ height: "28px", marginRight: "10px" }}
														className="floatLeft pd0 mr10" color={"primary"}
														value={isConfirmCheckbox}
														checked={isConfirmCheckbox}
														onChange={(e, v) => {
															setIsConfirmCheckbox(v);
															setFormType(formType);
														}}
														inputProps={{ "aria-label": "uncontrolled-checkbox" }} />
													<Typography variant="caption">
														<span>I verify that my total unearned income is </span>
														<NumberFormat
															value={totalValues || 0}
															displayType={"text"}
															thousandSeparator={true}
															prefix={"$"}
														/>.
														<span className="requiredHighlight">*</span>
													</Typography>
												</div>
												{
													!isConfirmCheckbox &&
													<p style={{ margin: 0 }}>
														<span
															style={{ color: "#FF1744", fontSize: 12 }}> Required Field </span>
													</p>
												}
											</Grid>
										</Grid>
									}
								</form>
							);
						}}
				</Formik>
			</Grid>
		</Grid>
	);
};

export default UnearnedIncomePastYear;